export const contactTypes = [
    "Caregiver",
    "Customer",
    "Internal",
    "Payer",
    "Pharmacy",
    "Provider",
];
